module.exports = __webpack_public_path__ + "static/media/logo3.6371db3d.png";